



import { Component, Vue } from 'vue-property-decorator';
import ListSelector from '@/shared/components/ListSelector.component.vue';

import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';

@Component({
  components: {
      Modal,
      ListSelector,
  },
})

export default class ModalPartial extends Vue {

  private isModalOpen = false;
  private List = [
    { id: 1, name: 'Alicante' },
    { id: 2, name: 'Murcia' },
    { id: 3, name: 'Valencia' },
    { id: 4, name: 'Barcelona' },
    { id: 5, name: 'Castellón' },
    { id: 6, name: 'Madrid' },
  ];
  private subtitles = 'Elige otra convocatoria del listado: ';
  private modalTitleColor = ModalTitleColor;

  private listElementSelected(element: any) {
    // console.log(element.name);
  }

  private modalActivate() {
    this.isModalOpen = true;
  }

  private closeModal() {
    this.isModalOpen = false;
  }
}
